const Nis = (window as any).Nis || {};
module.exports = Nis;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./node_modules/tslint-loader!./src/globals/Nis.ts